<div class="dash-card-tpl"
     [ngClass]="klass"
     [class.with-border]="withBorder">
    <div *ngIf="header"
         class="dash-card-tpl-header">
        <ng-content select="[dash-card-header]"></ng-content>
    </div>
    <div class="dash-card-tpl-body">
        <ng-content select="[dash-card-body]"></ng-content>
    </div>
    <div *ngIf="footer"
         class="dash-card-tpl-footer">
        <ng-content select="[dash-card-footer]"></ng-content>
    </div>
</div>
